
function Organization() {
    return (
        <div class="reg-text">
            <h1>Organization</h1>
            <p>The 2025 edition of the NAOI is proudly organized by the Algerian Olympiad in Informatics, and sponsored by the African Olympiad Academy.</p>
            <div class="sp-ct">
            <a href="https://algerianoi.com" class="logo-sp"><img src="/img/aoi.png"></img></a>
            <a href="https://africanolympiadfoundation.org/" class="logo-sp"><img src="/img/aoa.png"></img></a>
            </div>
            <h2>Call for Tasks</h2>
            <p>We warmly invite everyone to contribute to the preparation of tasks for this Olympiad. Submitted tasks should adhere to the requirements outlined in the <a href="https://ioinformatics.org/page/syllabus/12">IOI syllabus for the current year</a>.</p>
            <p>Each task submission must include:</p>
            <ul>
                <li>The task statement in English, preferably formatted as a PDF with all required diagrams and images included.</li>
                <li>A detailed description of the intended solution, including an algorithm capable of achieving full marks.</li>
            </ul>
            <p>Submissions must remain confidential until the contest day. Please email your submissions to <a href="mailto:naoi2025@algerianoi.com">naoi2025@algerianoi.com</a> by <strong>March 15<sup>th</sup>, 2025</strong>.</p>

            <h2>Registration</h2>
            <p>Participating countries are invited to send their delegations, comprising one team leader and up to six contestants, to <a href="mailto:naoi2025@algerianoi.com">naoi2025@algerianoi.com</a>. The registration deadline is <strong>March 31<sup>st</sup>, 2025</strong>.</p>
            <p>Delegations are kindly asked to mention for each member of the delegation their full name, birthdate, email address and picture (if they consent to get it published on the official website).</p>
        </div>

    );
}

export default Organization;
